import React, { useState, useEffect } from "react";
import "./Home.scss";
import { getUserAnalytics } from "../../api/apiServiceFetch";
import WorldMap from "./WorldMap";
import "devextreme/dist/css/dx.light.css";
import {
	BarChart,
	Bar,
	PieChart,
	Pie,
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	Cell,
	ResponsiveContainer,
} from "recharts";

const Analytics = () => {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [userAnalytics, setUserAnalytics] = useState();

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			setError(null);
			try {
				const [analyticsData] = await Promise.all([getUserAnalytics()]);
				setUserAnalytics(analyticsData);
			} catch (err) {
				console.error("Ошибка при загрузке данных:", err);
				setError("Не удалось загрузить данные.");
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, []);

	if (loading)
		return (
			<div className="loading">
				<p>Loading...</p>
			</div>
		);
	if (error)
		return (
			<div className="error">
				<p style={{ color: "red" }}>{error}</p>
				<button onClick={() => window.location.reload()}>Try Again</button>
			</div>
		);

	const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
	return (
		<div className="home">
			<div className="analytics">
				<div className="mobile-stats">
					{[
						["Telegram Mini App", "telegram"],
						["Android", "android"],
						["iOS", "ios"],
						["Браузер", "web"],
						["Установленное", "pwa"],
						["Приложение + Telegram", "mobileAndTelegram"],
					].map(([label, key]) => (
						<div className="mobile-stat-card" key={key}>
							<span className="mobile-stat-label">{label}</span>
							<span className="mobile-stat-value">
								{userAnalytics?.channels?.[key]?.total ?? 0}
							</span>
							<span className="mobile-stat-label">
								за 30 дней: {userAnalytics?.channels?.[key]?.active30 ?? 0}
							</span>
						</div>
					))}
					<div className="mobile-stat-card">
						<span className="mobile-stat-label">Привязан Telegram</span>
						<span className="mobile-stat-value">
							{userAnalytics?.channels?.telegramLinked ?? 0}
						</span>
						<span className="mobile-stat-label">накопительно</span>
					</div>
				</div>
				<p style={{ color: "#666", fontSize: 12, margin: "4px 0 16px" }}>
					«Привязан Telegram» — сколько аккаунтов вообще связаны с Telegram, за всё
					время. Остальные карточки — пользование: учёт ведётся с момента выката,
					поэтому Telegram, «Браузер» и «Установленное» начинают с нуля и
					наполняются по мере заходов. Android показывает накопленное сразу:
					приложение присылает эти данные давно.
				</p>
				<div className="grid-cols">
					<div>
						<div
							style={{
								display: "flex", // Use Flexbox to align children in a row
								flexDirection: "row", // Explicitly set row direction (default)
								justifyContent: "space-between", // Space out the components evenly
								alignItems: "flex-start", // Align items at the top
								gap: "20px", // Add spacing between PieChart and WorldMap
								width: "100%", // Ensure the container takes full width
								overflowX: "auto", // Allow horizontal scrolling if content overflows
							}}
						>
							<ResponsiveContainer width="20%" height={500}>
								<h3 className="text-md">По полу</h3>
								<PieChart>
									<Pie
										data={userAnalytics.sexDistribution}
										dataKey="value"
										nameKey="name"
										cx="50%"
										cy="50%"
										outerRadius={100}
										label
									>
										{userAnalytics.sexDistribution.map((entry, index) => (
											<Cell
												key={`cell-${index}`}
												fill={COLORS[index % COLORS.length]}
											/>
										))}
									</Pie>
									<Tooltip />
									<Legend />
								</PieChart>
							</ResponsiveContainer>

							<WorldMap data={userAnalytics.country} />
						</div>
						<div
							style={{
								overflowX: "auto",
								overflowY: "hidden",
								padding: "20px",
							}}
						>
							<ResponsiveContainer width="100%" height={300}>
								<h3 className="text-md">Геолокация</h3>
								<BarChart data={userAnalytics.country}>
									<CartesianGrid strokeDasharray="3 3" />
									<XAxis dataKey="location" />
									<YAxis />
									<Tooltip />
									<Legend />
									<Bar dataKey="count" fill="#8884d8" name="Количество" />
								</BarChart>
							</ResponsiveContainer>
						</div>
					</div>

					<div
						style={{ overflowX: "auto", overflowY: "hidden", padding: "20px" }}
					>
						<ResponsiveContainer width="100%" height={400}>
							<h3 className="text-md">Регистрации</h3>
							<LineChart data={userAnalytics.registrationTrends}>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="createDate" />
								<YAxis />
								<Tooltip />
								<Legend />
								<Line
									type="monotone"
									dataKey="count"
									stroke="#1f77b4"
									name="Регистрации"
								/>
								<Line
									type="monotone"
									dataKey="delCount"
									stroke="#d62728"
									name="Удаления"
								/>
								<Line
									type="monotone"
									dataKey="modCount"
									stroke="#2ca02c"
									name="Прошли модерацию"
								/>
								<Line
									type="monotone"
									dataKey="blockCount"
									stroke="#ff7f0e"
									name="Заблокировано"
								/>
							</LineChart>
						</ResponsiveContainer>
					</div>
					<div
						style={{ overflowX: "auto", overflowY: "hidden", padding: "20px" }}
					>
						<ResponsiveContainer width="100%" height={400}>
							<h3 className="text-md">Активность</h3>
							<BarChart data={userAnalytics.loginActivity}>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="createDate" />
								<YAxis />
								<Tooltip />
								<Legend />
								<Bar
									type="monotone"
									dataKey="count"
									fill="#82ca9d"
									name="Количество"
								/>
							</BarChart>
						</ResponsiveContainer>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Analytics;
